var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "a",
      {
        ref: "btnDropdownRef",
        staticClass: "text-blue-700 block",
        attrs: { href: "javascript:void(0)" },
        on: {
          click: function($event) {
            return _vm.toggleDropdown($event)
          }
        }
      },
      [
        _c("div", { staticClass: "items-center flex" }, [
          _c(
            "span",
            {
              staticClass:
                " text-white inline-flex items-center justify-center rounded-full"
            },
            [
              _vm._v("\n        Hi, " + _vm._s(_vm.getName) + " "),
              _c("i", { staticClass: "fa fa-caret-down ml-2 text-sm" })
            ]
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "popoverDropdownRef",
        staticClass:
          "bg-white text-base z-50 float-left py-2 list-none text-left rounded shadow-lg w-48",
        class: {
          hidden: !_vm.dropdownPopoverShow,
          block: _vm.dropdownPopoverShow
        }
      },
      [
        _c(
          "a",
          {
            staticClass:
              "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blue-700",
            attrs: { href: "javascript:void(0);" },
            on: {
              click: function($event) {
                return _vm.toggleDD($event, "profile")
              }
            }
          },
          [_vm._v("\n      Profile\n    ")]
        ),
        _vm._v(" "),
        !_vm.isSuperAdmin
          ? _c(
              "a",
              {
                staticClass:
                  "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blue-700",
                attrs: { href: "javascript:void(0);" },
                on: {
                  click: function($event) {
                    return _vm.toggleDD($event, "change-password-user")
                  }
                }
              },
              [_vm._v("\n      Change Password\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "h-0 my-2 border border-solid border-blueGray-100"
        }),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass:
              "text-sm py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blue-700",
            attrs: { href: "javascript:void(0);" },
            on: { click: _vm.logout }
          },
          [_vm._v("\n      Log Out\n    ")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c578d53e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c578d53e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/UserDropdown.vue
// module id = null
// module chunks = 